import useAppContext from "./useAppContext";

function useAppConfig() {
  const appContext = useAppContext();

  return appContext?.data?.appConfig || {};
}

export default useAppConfig;
